module.exports = __webpack_public_path__ + "img/img3.e41a446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/04/img3.png
// module id = 235
// module chunks = 0